import { Navigate, useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";
import { LS_ACTIVE_ASSESSMENT_LIST_KEY } from "../../../../core/constants/common";
import DataCollectionEventForm from "./DataCollectionEventForm";
import { DCE_EVENT_ID_PARAM, DCE_MODE, DCE_MODE_PARAM } from "./dceMode";
import "./CreateDataCollectionEvent.scss";

export const create_dce = "/company_admin/assessments/create_dce";
export const update_dce = "/company_admin/assessments/update_dce/<id>";
export const list_dec = "/company_admin/assessments";

export const getDuplicateDCEPath = (eventId) =>
	`${create_dce}?${DCE_MODE_PARAM}=${DCE_MODE.DUPLICATE}&${DCE_EVENT_ID_PARAM}=${eventId}`;

const toEventId = (value) => (Number(value) > 0 ? Number(value) : null);

// The update route carries the event in the path; duplicate is the create route with mode=duplicate&eventId=<id>
const resolveModeAndEventId = (pathId, searchParams) => {
	if (pathId != null) return { mode: DCE_MODE.UPDATE, eventId: toEventId(pathId) };

	if (searchParams.get(DCE_MODE_PARAM) === DCE_MODE.DUPLICATE) {
		return { mode: DCE_MODE.DUPLICATE, eventId: toEventId(searchParams.get(DCE_EVENT_ID_PARAM)) };
	}
	return { mode: DCE_MODE.CREATE, eventId: null };
};

/**
 * Route state (all optional): selfAssessment, openPermissions (update only: start on the permissions step),
 * returnTo / returnState (where Cancel/Save go back to; defaults to the DCE list).
 */
function CreateDataCollectionEvent() {
	const navigate = useNavigate();
	const location = useLocation();
	const { id } = useParams();
	const [searchParams] = useSearchParams();
	const { mode, eventId } = resolveModeAndEventId(id, searchParams);
	const routeState = location?.state ?? {};

	// Self/supplier view comes from the opener; without it, create is a self assessment and
	// update/duplicate follow the stored list choice
	const lsSelfValue = localStorage.getItem(LS_ACTIVE_ASSESSMENT_LIST_KEY);
	const selfAssessment = routeState.selfAssessment
		?? (mode === DCE_MODE.CREATE || (lsSelfValue ? lsSelfValue === 'self' : true));

	const goBack = () => navigate(routeState.returnTo ?? list_dec, { state: routeState.returnState });

	// Update/duplicate without a valid event id has nothing to load
	if (mode !== DCE_MODE.CREATE && !eventId) {
		return <Navigate replace to={mode === DCE_MODE.DUPLICATE ? create_dce : list_dec} />;
	}

	return (
		<DataCollectionEventForm
			key={`${mode}-${eventId ?? 'new'}`}
			mode={mode}
			id={eventId}
			enablePermCard={mode === DCE_MODE.UPDATE && !!routeState.openPermissions}
			selfAssessment={selfAssessment}
			onHide={goBack}
		/>
	);
}

export default CreateDataCollectionEvent;
